// extracted by mini-css-extract-plugin
export var bubble = "_45-0";
export var container = "_45-f";
export var contrastBorder = "_45-g";
export var greyOut = "_45-2";
export var initialsColor0 = "_45-3";
export var initialsColor1 = "_45-4";
export var initialsColor10 = "_45-d";
export var initialsColor11 = "_45-e";
export var initialsColor2 = "_45-5";
export var initialsColor3 = "_45-6";
export var initialsColor4 = "_45-7";
export var initialsColor5 = "_45-8";
export var initialsColor6 = "_45-9";
export var initialsColor7 = "_45-a";
export var initialsColor8 = "_45-b";
export var initialsColor9 = "_45-c";
export var initialsWrapper = "_45-1";
export var large = "_45-l";
export var medium = "_45-k";
export var mediumSmall = "_45-j";
export var mediumSmallMedium = "_45-o";
export var micro = "_45-h";
export var small = "_45-i";
export var tiny = "_45-n";
export var xTiny = "_45-m";